<ng-container *ngIf="isAdmin && imagePurpose === 'user'; else plain">
    <span [class]="'avatar-wrapper avatar-wrapper--' + initialsSize + ' is-admin'">
        <span class="avatar-inner">
            <ng-container *ngTemplateOutlet="content"></ng-container>
        </span>
        <span class="admin-badge">ADMIN</span>
    </span>
</ng-container>

<ng-template #plain>
    <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>

<ng-template #content>
    <!-- User initials fallback (legacy style) -->
    <span *ngIf="shouldShowInitials() && imagePurpose === 'user'" class="user-avatar-initials flex-shrink-0" [ngClass]="[initialsClass || 'user-avatar-initials--' + initialsSize, sizeClass]">{{ initials }}</span>

    <!-- Purpose-based placeholder: icon or initials -->
    <span *ngIf="shouldShowInitials() && imagePurpose !== 'user' && !isEmptyCircle()"
          class="app-image-placeholder flex-shrink-0"
          [ngClass]="[getPurposeClass(), 'user-avatar-initials', initialsClass || 'user-avatar-initials--' + initialsSize, sizeClass]">
        <i *ngIf="getPurposeIcon()" [class]="getPurposeIcon()"></i>
        <ng-container *ngIf="!getPurposeIcon()">{{ initials }}</ng-container>
    </span>

    <!-- Plain empty circle placeholder, sized by the parent .symbol wrapper (e.g. website bead) -->
    <span *ngIf="shouldShowInitials() && isEmptyCircle()" class="symbol-label rounded-circle bg-light-secondary" [ngClass]="sizeClass"></span>

    <!-- The image is loaded -->
    <img *ngIf="!shouldShowInitials() && delayPassed && fetched"
         [src]="getSrc()"
         [class]="getClasses()"
         [ngClass]="sizeClass"
         alt="image"
         (error)="handleImageError($event)"
         [style]="getStyles()"/>

    <!-- Placeholder: shown until the image is ready (also blinks/blurs when loading takes too long) -->
    <img *ngIf="!shouldShowInitials() && !(delayPassed && fetched)"
         [src]="imagePlaceholderURL"
         [class]="getClasses() + (delayPassed && fetching ? ' blink' : '') + (maxDelayDurationPassed ? ' blur' : '')"
         [ngClass]="sizeClass"
         alt="image"
         [style]="getStyles()"/>
</ng-template>
